export enum InformationLineVariant {
	ERROR = 'error',
	INFO = 'info',
	SUCCESS = 'success',
	HELPER = 'helper',
}
